import React from 'react';
import HomeDraftsListSection from '../../SHARED/components/HomeDraftsListSection';

const LAW_FIRM_DRAFTS_COPY = {
  title: 'Draft Bond Requests',
  subtitle: 'Continue working on your saved drafts.',
  emptyDrafts: 'You have no saved bond requests.',
  resume: 'Resume',
  delete: 'Delete',
};

const DraftBondRequestsSection = ({
  cachedBonds,
  loadingDrafts,
  getCacheRoute,
  navigate,
  handleDeleteDraft,
  deletingId,
  formatRelativeTime,
}) => (
  <HomeDraftsListSection
    copy={LAW_FIRM_DRAFTS_COPY}
    drafts={cachedBonds}
    draftCount={cachedBonds.length}
    loadingDrafts={loadingDrafts}
    deletingId={deletingId}
    resolveResumePath={(row) => getCacheRoute(row?.bond_type, row?.bond_cache_id)}
    onResume={(path) => navigate(path)}
    onDelete={handleDeleteDraft}
    formatRelativeTimeFn={formatRelativeTime}
  />
);

export default DraftBondRequestsSection;
